import {BasicFilter} from "@/lib/store/state/filters/BasicFilter";

export class SearchFilter extends BasicFilter {
    constructor() {
        super("q");
    }
}
